module.exports = __webpack_public_path__ + "img/capt_b.87a9353c.jpeg";